import { useState } from 'react';
import Slider from 'rc-slider';
import { colors } from 'components/styles/variables';
import numeral from 'numeral';

interface PriceRequestProps {
  vehiclePrice: number;
  disabled: boolean;
  className?: string;
}

export default function PriceRequest({
  vehiclePrice,
  disabled,
  className,
}: PriceRequestProps): JSX.Element {
  const [requestedPrice, setRequestedPrice] = useState(vehiclePrice);
  const minPrice = vehiclePrice * 0.9;

  return (
    <div className={`price-request ${className}`}>
      <div className="price-request-text">
        <div>Request a price: </div>
        <div className="price-request-price">
          <span>{numeral(requestedPrice).format('$0,0')}</span>
        </div>
      </div>
      <div className={`slider-container`}>
        <Slider
          disabled={disabled}
          aria-hidden="true"
          min={minPrice}
          max={vehiclePrice}
          trackStyle={{ height: 3, backgroundColor: colors.ALG2 }}
          defaultValue={requestedPrice}
          value={requestedPrice}
          onChange={(value): void => setRequestedPrice(value)}
        />
      </div>
      <style jsx>{`
        .price-request {
          margin-top: 20px;
        }
        .price-request-text {
          display: flex;
          justify-content: space-between;
          margin-bottom: 16px;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 24px;
          letter-spacing: 0.2px;
        }
        .price-request-price {
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: 28px;
          letter-spacing: 0.2px;
        }
        .slider-container :global(.rc-slider-disabled) {
          background-color: white;
        }
        .padding {
          padding: 0 16px;
        }
        .slider-container :global(.rc-slider-handle) {
          border: 1px solid ${colors.BLACK};
          background-color: ${colors.WHITE};
          width: 28px;
          height: 28px;
          margin-top: -12px;
          cursor: pointer;
        }
        .slider-container :global(.rc-slider-handle:active) {
          box-shadow: none;
        }
      `}</style>
    </div>
  );
}
